import { render, staticRenderFns } from "./UserRoleEdit.vue?vue&type=template&id=4f1c2358&scoped=true"
import script from "./UserRoleEdit.vue?vue&type=script&lang=js"
export * from "./UserRoleEdit.vue?vue&type=script&lang=js"
import style0 from "./UserRoleEdit.vue?vue&type=style&index=0&id=4f1c2358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c2358",
  null
  
)

export default component.exports